import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import CustomScrollDiv from '../forecast-app/shared/components/scroll-bars/custom_scroll_div';

class ShortcutModalContent extends Component {
	render() {
		return (
			<div className="shortcut-table">
				<CustomScrollDiv>
					<table>
						<thead>
							<tr>
								<th>
									<FormattedMessage id="shortcut_modal.hotkey" />
								</th>
								<th>
									<FormattedMessage id="shortcut_modal.action" />
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="shortcut-modal-sub-title">
									<FormattedMessage id="common.actions" />
								</td>
								<td />
							</tr>
							{/*<tr>
                            <td>Alt+Shift+N</td>
                            <td><FormattedMessage id="shortcut_modal.new-card"/></td>
                        </tr>*/}
							<tr>
								<td>Alt+Shift+X</td>
								<td>
									<FormattedMessage id="common.clear-filters" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+Q</td>
								<td>
									<FormattedMessage id="shortcut_modal.open-shortcuts" />
								</td>
							</tr>
							<tr>
								<td>
									<FormattedMessage id="shortcut_modal.space-description" />
								</td>
								<td>
									<FormattedMessage id="shortcut_modal.space-action" />
								</td>
							</tr>
							<tr>
								<td>
									<FormattedMessage id="shortcut_modal.bug-description" />
								</td>
								<td>
									<FormattedMessage id="shortcut_modal.bug-action" />
								</td>
							</tr>
							<tr>
								<td>
									<FormattedMessage id="shortcut_modal.block-description" />
								</td>
								<td>
									<FormattedMessage id="shortcut_modal.block-action" />
								</td>
							</tr>
							<tr>
								<td>
									<FormattedMessage id="shortcut_modal.arrow-right-description" />
								</td>
								<td>
									<FormattedMessage id="shortcut_modal.arrow-right-action" />
								</td>
							</tr>
							<tr>
								<td>
									<FormattedMessage id="shortcut_modal.arrow-left-description" />
								</td>
								<td>
									<FormattedMessage id="shortcut_modal.arrow-left-action" />
								</td>
							</tr>
							<tr>
								<td className="shortcut-modal-sub-title">
									<FormattedMessage id="shortcut_modal.navigation-inside" />
								</td>
								<td />
							</tr>
							<tr>
								<td>Alt+Shift+O</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-overview" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+1</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-workflow" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+2</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-scope" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+3</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-time-line" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+4</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-sprints" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+5</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-files" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+6</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-budget" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+7</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-team" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+8</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-client" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+9</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-rate-card" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+0</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-settings" />
								</td>
							</tr>
							<tr>
								<td className="shortcut-modal-sub-title">
									<FormattedMessage id="shortcut_modal.navigation-outside" />
								</td>
								<td />
							</tr>
							<tr>
								<td>Alt+Shift+W</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-upcoming" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+E</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-all-projects" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+R</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-time-reports" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+T</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-scheduling" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+Y</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-reports" />
								</td>
							</tr>
							<tr>
								<td className="shortcut-modal-sub-title">
									<FormattedMessage id="shortcut_modal.navigation-connected" />
								</td>
								<td />
							</tr>
							<tr>
								<td>Alt+Shift+O</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-overview" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+1</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-workflow" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+4</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-sprints" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+7</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-team" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+P</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-projects" />
								</td>
							</tr>
							<tr>
								<td>Alt+Shift+0</td>
								<td>
									<FormattedMessage id="shortcut_modal.navigation-settings" />
								</td>
							</tr>
						</tbody>
					</table>
				</CustomScrollDiv>
			</div>
		);
	}
}

ShortcutModalContent.propTypes = {};

export default ShortcutModalContent;
